import { ref as _ref, computed as _computed } from 'vue'
import { useStorage } from '@vueuse/core';
import { Location } from 'vue-router';
import { set, del } from 'vue';

export interface Search {
  query: Location['query'];
  name: string;
}

export interface SearchStore {
  [key: string]: {
    [key: string]: Search;
  };
}

const searches = (useStorage<SearchStore>('searches', {}, localStorage, { mergeDefaults: true }));

const useSaveSearch = (searchDomain: keyof SearchStore) => {
  if (!searches.value[searchDomain] && searchDomain) {
    set(searches.value, searchDomain, {});
  }

  let selectedSearch = _ref<string | null>(null);

  const saveSearch = (name: string, query: Location['query']) => {
    const id = Date.now().toString();
    set(searches.value[searchDomain], id, {
      query,
      name,
    });
    selectedSearch.value = id;
  };

  const resetSelectedSearch = () => {
    selectedSearch.value = null;
  };

  const domainSearches = _computed(() => searches.value[searchDomain]);

  const items = _computed(() => Object.entries(domainSearches.value).map(([key, value]) => ({
    value: key,
    text: value.name,
    query: value.query,
  })));

  const hasSearches = _computed(() => Object.keys(searches.value[searchDomain]).length > 0);

  const deleteSearch = (domain: keyof SearchStore, id: string) => {
    const numberId = Number(id);
    if (numberId) {
      del(searches.value[domain], numberId);
    }
  };

  return ({
    searches,
    saveSearch,
    deleteSearch,
    hasSearches,
    items,
    selectedSearch,
    resetSelectedSearch,
  });
};

export default useSaveSearch;
